import defaultImage from '../assets/default-image.png';
const generateImageUrl = url => {
  if (url && url.indexOf('http') !== 0) {
    return `${process.env.REACT_APP_IMAGES_HOST_ENDPOINT}${url}`;
  }
  return url || defaultImage;
};
const generatePublicImageUrl = (url, returnNoUrl = false) => {
  if (url && url.indexOf('http') !== 0 && !returnNoUrl) {
    return `${process.env.REACT_APP_S3_BUCKET_URL}${process.env.REACT_APP_ENVIRONMENT}${url}`;
  }
  if (returnNoUrl) {
    return `${process.env.REACT_APP_S3_BUCKET_URL}${process.env.REACT_APP_ENVIRONMENT}`;
  }
  return url || defaultImage;
};
const generateProfileImageUrl = userId => {
  if (!userId) {
    return defaultImage;
  }
  return `${process.env.REACT_APP_IMAGES_HOST_ENDPOINT}/assets/images/users/${userId}.png`;
};
export { generateImageUrl, generateProfileImageUrl, generatePublicImageUrl };